import { Box } from '@chakra-ui/react';

interface MentionChipProps {
  name: string;
  entity: string;
}

export const MentionChip = ({ name, entity }: MentionChipProps) => (
  <Box
    as="span"
    display="inline-block"
    px="6px"
    mx="1px"
    borderRadius="6px"
    bg="primary-50"
    color="primary-700"
    fontWeight={500}
    title={entity}
    sx={{ whiteSpace: 'nowrap', verticalAlign: 'baseline' }}
  >
    @{name}
  </Box>
);
